import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var jQuery: any;
@Component({
  selector: 'app-pointtable',
  templateUrl: './pointtable.component.html',
  styleUrls: ['./pointtable.component.scss']
})
export class PointtableComponent implements OnInit {
  url: string = "https://www.footballwebpages.co.uk/embed.js defer";
  //urlSafe: SafeResourceUrl;
  //iframeurl: any = "";
  constructor() { }

  ngOnInit() {
    //this.iframeurl = "https://www.footballwebpages.co.uk/embed.js";
    jQuery("#nvplay-data").html(`<div class="fwp-embed" data-background-color="#000000" data-color="#fffb00" data-border-color="#ff2600" data-heading-color="#ff2600" data-hover-background-color="#0433ff" data-url="northern-premier-league-premier-division/league-table"></div><script src="https://www.footballwebpages.co.uk/embed.js" defer></script>`);
    setTimeout(() => {

      //this.matchid = "4334868b-d932-483f-93af-f58184048dbb";
     
    this.loadScript('https://www.footballwebpages.co.uk/embed.js' );
    
    }, 1000);
  }
  public loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

}
